import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { ErrorDto } from '../../../models/dtos/error.dto';
import { LoginRequest } from '../../../models/requests/login.request';
import { resetForcedLogoutGuard } from '../../axios';
import { Errors } from '../../errors';
import loginRequest from './login.repository';

/**
 * Backend'in gonderdigi govdeye HTTP status ekleniyor: captcha zorunlulugu
 * 428 ile bildiriliyor ve `ErrorDto.status` alani govdedeki metinsel deger
 * oldugu icin transport status'u ayrica tasinmali.
 */
export type LoginErrorDto = ErrorDto & { httpStatus?: number };

type InitialState = {
  loading: boolean;
  error?: LoginErrorDto;
};

const initialState: InitialState = {
  loading: false,
  error: undefined,
};

/**
 * Token artik yanit govdesinde donmuyor; HttpOnly cerezde tasindigi icin
 * panelin saklayacagi bir sey yok.
 *
 * Hata `rejectWithValue` ile donuyor: catch'teki `error` gercek Axios hatasi
 * oldugu icin `Errors.getErrorDtoFromApiError` gercek `response.data`'yi
 * (dolayisiyla backend'in `code` alanini) okuyabiliyor. `rejectWithValue`
 * kullanilmasaydi RTK, `action.error`'i `response` alani olmadan serilestirir
 * ve `code` her zaman kaybolurdu.
 */
export const login = createAsyncThunk<void, LoginRequest, { rejectValue: LoginErrorDto }>(
  'login',
  async (request, { rejectWithValue }) => {
    try {
      await loginRequest(request);
      // Yeni oturum: onceki zorla-cikis kilidi kalkmali.
      resetForcedLogoutGuard();
    } catch (error: any) {
      return rejectWithValue({
        ...Errors.getErrorDtoFromApiError(error),
        httpStatus: error?.response?.status,
      });
    }
  }
);

const loginSlice = createSlice({
  name: 'login',
  initialState,
  reducers: {
    loginReset: (state) => {
      state.loading = false;
      state.error = undefined;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(login.pending, (state) => {
      state.loading = true;
      state.error = undefined;
    });
    builder.addCase(login.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(login.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
  },
});

export default loginSlice.reducer;
export const { loginReset } = loginSlice.actions;
